import React from "react";
import Invs from "../Apm/Inv/Invs";

const MyInvs = () => {
  return (
    <React.Fragment>
      <Invs />
    </React.Fragment>
  );
};

export default MyInvs;
